import {Component, Vue} from 'vue-property-decorator'
import {addClasses} from "@/api/classManage";
import {getProjectAllList} from "@/api/projectList";
import {delNullProperty} from "@/utils";
import {formatDate} from "@/utils/timeFilter";
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";
import commonData from "@/utils/commonData"

@Component({
    components: {
        MoreUsersFilter
    }
})
export default class AddClass extends Vue {
    formModel = {
        name: '',
        code: '',
        teacherUserId: '',
        thesisUserId: '',
        helperUserId: '',
        applyUserId: '',
        projectAllId: '',
        souCourseTypeId: '', // 项目类型
        createdAt: null, // 开课时间
        souCourseName: '', // 项目名称
        remark:''
    }
    formRules = {
        name: [{required: true, message: '请填写班级名称', trigger: 'blur'}],
        souCourseTypeId: [{required: true, message: '请选择项目类型', trigger: ['blur', 'change']}],
        createdAt: [{required: true, message: '请选择开课时间', trigger: ['blur', 'change']}],
        souCourseName: [{required: true, message: '请选择项目名称', trigger: ['blur', 'change']}],
    }
    recordId = ''
    typeList = commonData.projectTypeArray
    // 开课时间
    isShow = null
    projectList = []
    page = 1
    limit = 20
    total = 0
    disabledBtn = false
    pageSize = 20
    name = '' // 远程搜索name
    loading = false
    projectDialogTableData = []
    projectDialogShow = false
    dialogProjectInputValue = ''
    timer = null
    dialogProjectTotal = 0
    projectDialogCheckedTable = {
        souCourseSchoolBegin: '',
        id: '',
        souCourseName: ''
    }
    pageloading = false

    created() {
        this.recordId = String(this.$route.query.id)
    }


    // 保存
    doSave() {
        let flag = true;
        (this.$refs.dynamicValidateForm as HTMLFormElement).validate((valid: boolean) => {
            if (!valid) {
                flag = false
                return;
            }
        })
        const obj = {
            name: this.formModel.name,
            projectAllId: this.formModel.projectAllId,
            code: this.formModel.code.trim(),
            teacherUserId: this.formModel.teacherUserId,
            thesisUserId: this.formModel.thesisUserId,
            helperUserId: this.formModel.helperUserId,
            applyUserId: this.formModel.applyUserId,
            remark:this.formModel.remark,
        }
        if (flag) {
            this.disabledBtn = true
            this.pageloading = true
            addClasses(delNullProperty(obj)).then(res => {
                this.$message.success('新增班级成功')
                this.disabledBtn = false
                this.pageloading = false
                setTimeout(() => {
                    window.close()
                }, 500)
            }).catch(res => {
                this.disabledBtn = false
                this.pageloading = false
            })
        }
    }


    // 时间区间过滤器
    changeTime(val: Date[]): string {
        if (val == null) return ''
        let time = ''
        val.forEach((item: any) => {
            time += formatDate('yyyy-MM-dd', new Date(item)) + '/'
        })
        time = time.slice(0, time.length - 1)
        return time
    }


    changeTeacherUsers(e) {
        this.formModel.teacherUserId = e.id
    }

    changeThesisUsers(e) {
        this.formModel.thesisUserId = e.id
    }

    changeHelperUsers(e) {
        this.formModel.helperUserId = e.id
    }

    changeApplyUserId(e) {
        this.formModel.applyUserId = e.id
    }


    changeType(val) {
        this.formModel.souCourseName = ''
        this.formModel.createdAt = null
        this.name = ''
        this.limit = 20
        this.page = 1
        this.formModel.projectAllId = ''
        this.projectList = []
        if (val)
            this.getProjectList();

    }


    projectInputFocus() {
        this.page = 1
        if (!this.formModel.souCourseTypeId) {
            this.$message.error('请选择项目类型')
            return
        }
        this.projectDialogShow = true
        this.getProjectList();
        (this.$refs.projectInput as HTMLFormElement).blur()
    }

    projectPageChange(page: number) {
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.page = page
            this.getProjectList()
        }, 1000)
    }

    async getProjectList() {
        this.loading = true
        const data: any = await getProjectAllList(delNullProperty({
            typeId: Number(this.formModel.souCourseTypeId),
            schoolBegin: this.changeTime(this.formModel.createdAt),
            limit: this.limit,
            souCourseName: this.dialogProjectInputValue,
            page: this.page,
        }))
        this.projectDialogTableData = data.projectAllList;

        // toggleRowSelection
        //  取消列表选中
        this.$nextTick(()=>{
            const dialogProjectTable = this.$refs.dialogProjectTable as HTMLFormElement
            if (this.projectDialogCheckedTable.id) {
                dialogProjectTable.clearSelection()
            }
            this.projectDialogTableData.map((item) => {
                if (item.id === this.formModel.projectAllId) {
                    dialogProjectTable.toggleRowSelection(item, true)
                }
            })

        })

        this.dialogProjectTotal = data.allNum
        this.loading = false
    }

    projectLimitChange(limit: number) {
        this.limit = limit
        this.getProjectList()
    }

    doCancel() {
        this.projectDialogShow = false
    }

    async clickProjectDialogConfirmButton() {
        this.formModel.projectAllId = this.projectDialogCheckedTable.id
        this.formModel.createdAt = [this.projectDialogCheckedTable.souCourseSchoolBegin, this.projectDialogCheckedTable.souCourseSchoolBegin]
        const arr = this.projectDialogCheckedTable.souCourseName.split('\n')
        this.formModel.souCourseName = arr[0]
        this.projectDialogShow = false
    }

    dialogProjectTableCheckedChange(selection) {
        /*
        * 复选框单选*/
        if (selection.length > 0) {
            this.projectDialogCheckedTable = JSON.parse(JSON.stringify(selection[0]))
            const dom = this.$refs.dialogProjectTable as HTMLFormElement
            if (selection.length > 1) {
                dom.clearSelection();
                dom.toggleRowSelection(selection.pop());
            }
        }
    }

    changeCreatedAt(){
        this.formModel.projectAllId = ''
        this.formModel.souCourseName = ''
    }

}
